module.exports = __webpack_public_path__ + "static/the-consolations-of-philosophy-8b11ff78c4362e0f250e4008c847242c.jpg";